import {
  DEFAULT_TABLE_UI_THEME,
  TABLE_UI_THEME_STORAGE_KEY,
  getTableUiThemePreset,
  normalizeTableUiThemeId,
} from './tableUiTheme';

function readInitialTableUiThemeId() {
  try {
    if (typeof localStorage !== 'undefined') {
      const stored = localStorage.getItem(TABLE_UI_THEME_STORAGE_KEY);
      if (stored) return normalizeTableUiThemeId(stored);
    }
  } catch {
    /* ignore */
  }
  return normalizeTableUiThemeId(DEFAULT_TABLE_UI_THEME);
}

let activeThemeId = readInitialTableUiThemeId();

const listeners = new Set();

export function getActiveTableUiThemeId() {
  return activeThemeId;
}

export function getActiveTableUiPreset() {
  return getTableUiThemePreset(activeThemeId);
}

export function isRefinedTableUi() {
  return activeThemeId === 'refined';
}

export function subscribeTableUiTheme(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function notifyListeners() {
  listeners.forEach((fn) => fn(activeThemeId));
}

export function applyTableUiTheme(themeId, { persist = true } = {}) {
  const next = normalizeTableUiThemeId(themeId);
  if (next === activeThemeId) return activeThemeId;

  activeThemeId = next;

  if (typeof document !== 'undefined') {
    document.documentElement.dataset.tableUi = next;
  }

  if (persist && typeof localStorage !== 'undefined') {
    localStorage.setItem(TABLE_UI_THEME_STORAGE_KEY, next);
  }

  notifyListeners();
  return next;
}

export function initTableUiThemeOnDocument() {
  if (typeof document !== 'undefined') {
    document.documentElement.dataset.tableUi = activeThemeId;
  }
}

/** Programmatic switch — e.g. `window.__applyTableUiTheme('legacy')` in devtools. */
if (typeof window !== 'undefined') {
  window.__applyTableUiTheme = (id) => applyTableUiTheme(id);
  window.__getTableUiTheme = () => activeThemeId;
}

initTableUiThemeOnDocument();
